export const FirebaseConfig = {
	"projectId": "taxibookingpage",
	"appId": "1:1058688982072:web:38f10726601646ed001acd",
	"databaseURL": "https://taxibookingpage-default-rtdb.firebaseio.com",
	"storageBucket": "taxibookingpage.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyAYTQhs2wSq71PQ06L_qy-cGzPzaxzGARE",
	"authDomain": "taxibookingpage.firebaseapp.com",
	"messagingSenderId": "1058688982072"
};